import React from 'react';
import { createRoot } from 'react-dom/client';

// i18n first: the shared ApiClientProvider translates numeric API error codes
// through i18n.exists('errorcode.NNNNNN'), so it has to be initialised before any
// request can fail.
import { bcp47, detectLanguage, loadLanguage } from '@/i18n';

import '@/theme/global.css';
import { applyInitialTheme } from '@/theme/ThemeProvider';
import { App } from '@/App';

// Set the CSS custom properties before the first paint — the provider does it from
// an effect, which is one frame too late.
applyInitialTheme();

// index.html is served with lang="en" because it is one static file for eight
// languages. Correct it before mount so screen readers and the browser's own
// translation prompt see the language actually about to render.
const initialLang = detectLanguage();
document.documentElement.lang = bcp47(initialLang);

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

const mount = () => {
    createRoot(container).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
};

// Non-English visitors get their locale chunk before the first render rather than
// a flash of English. A failed fetch still mounts — English is bundled, so the
// page is readable either way.
if (initialLang === 'en') {
    mount();
} else {
    void loadLanguage(initialLang).catch(() => undefined).then(mount);
}
